const convertFrom24h = (time: string): string => {
  const hours = parseInt(time.substring(0, 2), 10);
  const minutes = parseInt(time.substring(2), 10);

  const period = hours >= 12 ? 'pm' : 'am';
  const formattedHour = ((hours + 11) % 12) + 1;

  if (minutes === 0) return `${formattedHour}${period}`;
  return `${formattedHour}:${minutes.toString().padStart(2, '0')}${period}`;
};

export const getSalesLineHours = () => {
  const dayOfWeek = new Date().getDay();
  const hours = (window.Jbhifi.jbSalesLineHours?.[dayOfWeek] ?? [])
    .map(timeString => timeString.trim().padStart(4, '0'))
    .map(time => convertFrom24h(time));

  if (hours.length !== 2) return undefined;

  return `${hours[0]}–${hours[1]}`;
};
